import { t } from '@lingui/core/macro';

export default function templateNameValidator(templateName?: string, existNames?: string[]) {
  if (!templateName || templateName.length <= 0) {
    return t`Название шаблона не может быть пустым`;
  }
  if (existNames && existNames.includes(templateName)) {
    return t`Такое название уже существует, придумайте новое`;
  }
  return undefined;
}
